import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import MailchimpAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/MailchimpAppIcon';

import MailchimpButton from '../OtherComponents/MailchimpButton';

const MailchimpStrategy = {
  previewInfo: {
    name: 'Mailchimp',
    iconSvg: <MailchimpAppIcon size="jumbo" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Mailchimp',
    category: 'Send newsletters and email blasts to your customers',
    details: (
      <div>
        Housecall Pro and Mailchimp work together to provide you with the simplest, most affordable way to stay in
        contact with your customers via email. Connect your Mailchimp account to Housecall Pro to sync your customer
        lists and email to create campaigns that drive real results for your business.
        <br />
        <br />
        Enable Mailchimp and Housecall Pro today and send your first email campaign in less than 5 minutes.
        <br />
        <br />
        <ul>
          <li>Sync your Housecall Pro customer list with Mailchimp to automatically create audiences</li>
          <li>
            Send one-time email blasts to let your customers know about promotional deals, seasonal services,
            operational changes, or anything, really!
          </li>
          <li>Automatically include a link to your online booking page</li>
        </ul>
      </div>
    ),
    iconSvg: <MailchimpAppIcon size="jumbo" />,
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    description: (
      <Grid container spacing={8}>
        <Grid item>
          <Typography align="left" variant="body1">
            <a href="https://mailchimp.com/pricing" target="_blank" rel="noreferrer">
              https://mailchimp.com/pricing
            </a>
          </Typography>
        </Grid>
        <Grid item>
          <Typography align="center" color="textSecondary">
            Plans from $0 - $350/month
          </Typography>
        </Grid>
      </Grid>
    ),
    appActionButton: <MailchimpButton />,
  },
};

export default MailchimpStrategy;
